// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"a067763b","118":"6c7d8ccf","510":"132ce43b"}[chunkId] + ".chunk.js";
};